import React from 'react';
import { graphql } from "gatsby";

import SEO from "../../../components/en/seo/Seo";
import Header from "../../../components/en/headers/Header";
import Footer from "../../../components/en/layouts/Footer";
import FluorescenceGoodToKnow from "../../../components/en/fluorescence/FluorescenceGoodToKnow";
import CallToAction from "../../../components/en/layouts/CallToAction";
import FluorescenceHeader from "../../../components/en/fluorescence/FluorescenceHeader";
import FluorescenceDescription from "../../../components/en/fluorescence/FluorescenceDescription";
import FluorescenceGallery from "../../../components/en/fluorescence/FluorescenceGallery";

function MineFluorescence({data}) {
    return (
        <>
            <SEO
                title="Mine Fluorescence"
                description="Experience the mysterious power of the underground in a completely different way! The walk through the mine is a guided experience in the tunnels, where UV lamps are used to take you on a sensory and visual exploration of the wonderful mineral structures and other surprises underground."
            />
            <Header />
            <FluorescenceHeader/>
            <FluorescenceDescription/>
            <FluorescenceGoodToKnow/>
            <FluorescenceGallery imagesData={data.source.edges}/>
            <CallToAction/>
            <Footer/>
        </>
    );
}

export const pageQuery = graphql`
    query ImagesForFluorescenceGalleryInEnglish {
        source: allFile(filter: {relativePath: {regex: "rudnik/rudniska-florescenca-galerija/"}}) {
            edges {
                node {
                    childImageSharp {
                        thumb: gatsbyImageData(
                            width: 200
                            height: 200
                            placeholder: BLURRED
                        )
                        full: gatsbyImageData(layout: FULL_WIDTH)
                    }
                }
            }
        }
    }
`;

export default MineFluorescence;
